<div class="row card margin-bottom-60">
  <div class="card-header heading pad-horizontal-20">
    <span class="icon-money margin-right-10"></span>
    <span>OPTIONAL DISCOUNTS</span>
  </div>

  <div class="pad-10">
    <div
      [formGroup]="form"
      class="row pad-horizontal-10 sm-pad-horizontal-50 pad-vertical-10 sm-pad-vertical-30"
    >
      <div class="column ten pad-left-40 pad-right-20">
        <h2 class="coverage-heading">Go Paperless</h2>
        <p class="pad-bottom-20">
          Get your policy Documents electronically and save money on your insurance.
        </p>
        <strong
          >Checking the box indicates you agree to the Terms & Conditions. You can read those
          <a>here</a>.</strong
        >
      </div>
      <div class="column two md-pad-left-20 pad-top-60 md-pad-top-20" (click)="toggleCtrl()">
        <input
          class="checkbox"
          type="checkbox"
          id="goPaperlessCtrl"
          formControlName="goPaperlessChecked"
          (change)="toggleCtrl()"
        />
        <label class="checkbox-label"></label>
      </div>
    </div>
  </div>
</div>
